import { PRIVILEGED_MSID_WHITELIST, LS_OTP_VERIFIED_NUMBER, DEPLOYMENT_ENV_WHITELIST, SUPER_USER_TOGGLE_DROPDOWN_ENABLED, SESSION_SUPERUSER, PORTAL_DISPLAY_NAME_MAP, HSID_PERSONAL_REPRESENTATIVE, HSID_BASE, HSID_PARTIAL_REGISTRATION, ADD_ACCOUNT, HIGHLIGHTED_VALUES_IN_PORTAL_DROPDOWN, SDK_PORTAL_LIST, PORTAL_MAP, VIEW_POLICY_EXTERNAL_LINKS, MIMIC_EXTERNAL_LINKS, OPTUMLABSLOOP, DISPLAY_NAME_CHANGED_PRTLS, SESSION_SUPERVISORUSER, SESSION_TIER1USER, SESSION_BASELINEAGENT} from "../shared/Constants";
import { isPortalNameDisabled } from "./PortalNameDisabledState";
import moment from "moment";

export const updateObject = (oldState, updatedValues) => {
    return {
        ...oldState,
        ...updatedValues
    }
}

export const maskSubscr = (value) => {
    if(value != null ) {
        if(value.length < 3) {
            value = "XXX";
        } else {
            value = "XXX" + value.substr(3,value.length);
        }
    } else {
        value = "";
    }

    return value;
};

export const checkValidity = (value, rules) => {

    let isValid = true;
    let message = null;

    if(rules.required) {
        isValid = value && isValid;
        // console.log("[Utility] checkvalidity: required"+rules.required, value, isValid);
    }

    if(rules.minlength) {
        isValid = value.length >= rules.minlength && isValid;
        // console.log("[Utility] checkvalidity: minlength"+rules.minlength, value, isValid);
        message = !isValid & message===null?"Min "+rules.minlength+" characters required":message;
    }

    if(rules.maxlength) {
        isValid = value.length <= rules.maxlength && isValid;
        // console.log("[Utility] checkvalidity: maxlength"+rules.maxlength, value.length, isValid);
        message = !isValid & message===null?"Max "+rules.maxlength+" characters allowed":message;
    }

    if(rules.nospace) {
        isValid = (value.indexOf(' ')<0) && isValid;
        // console.log("[Utility] checkvalidity: nospace"+rules, value, isValid);
        // message="No spaces allowed";
        message = !isValid & message===null?"No spaces allowed":message;
    }

    if(rules.specialchar) {
        // let containsSpecial = false;
        rules.specialchar.map(char => {
            return isValid = (value.indexOf(char)<0) && isValid;
        });
        // console.log("[Utility] checkvalidity: specialchar", value, isValid);
        message = !isValid & message===null?"Contains invalid special characters":message;
    }

    if(rules.patternRegex) {
      isValid = rules.patternRegex.test(value)
      message = !isValid & message===null?(rules.patternRegexMessage ?? "Only alphabets and ` - [ ] ' . are allowed"):message;
    }

    if(rules.restrictFuture) {
        const target = (new Date(value)).setHours(0,0,0,0);
        const today = (new Date()).setHours(0,0,0,0);

        // console.log("[Utility] checkvalidity: restrictFuture:", value, target, today, isValid, value.indexOf("_"));
        isValid = target <= today && isValid;
        // console.log("[Utility] checkvalidity: restrictFuture:", target <= today, value.indexOf("_"));
        message = !isValid & message === null ? value.indexOf("_")===-1? "Future date not allowed":"Invalid Date" : message;
    }

    return {isValid: isValid, message: message};
}

export const clearForm = (form, ignoreFields) => {
    let clearForm = {...form}
    for(let formElement in clearForm){
        if(ignoreFields.indexOf(formElement) < 0) {
            clearForm[formElement].value = '';
            clearForm[formElement].touched = false;
            clearForm[formElement].valid = true;
        }
    }
    return clearForm;
}

export const checkHeadlessUser = (userName) => {
    return userName.startsWith("HSID_SSO_");
}

export const checkBankUser = (memberPortalList) => {
    const capPortal = memberPortalList.find(portal => {return portal.portalShortNm === "CAP"});
    return capPortal?true:false;
}

export const checkSuperUser = (userType) => {
    return userType===SESSION_SUPERUSER
}

export const checkSuperVisorUser = (userType) => {
  return userType===SESSION_SUPERVISORUSER
}

export const checkTier1User = (userType) => {
  return userType===SESSION_TIER1USER
}

export const isBasicMemberAccount = (accountType) => accountType === HSID_BASE;

export const getPortalDisplayName = (portalShortNm, portals) => {
    if (DISPLAY_NAME_CHANGED_PRTLS.has(portalShortNm) && portals) {
      return portals.find(val => val.portalShortName === portalShortNm)?.portalDisplayName
    }
    const portalDisplayName = PORTAL_DISPLAY_NAME_MAP[portalShortNm];
    return (portalDisplayName)? portalDisplayName: portalShortNm;
}

export const decodeBase64 = (encodedStr) => {
    try {
        return atob(encodedStr)
    } catch(e) {
        return null
    }
}

export const getOtpVerifiedNumber = () => {
  const localNumber = decodeBase64(localStorage.getItem(LS_OTP_VERIFIED_NUMBER));
  let number = {}
  try {
    number = JSON.parse(localNumber);
  } catch (e) {
    number = {}
  }
  return number
}

export const getEnabledPortalUrl = (needAllPortals, baseUrl) => {
    const enabledPortalUrl = baseUrl+"enabledPortals";
    if(needAllPortals){
        return enabledPortalUrl;
    }
    //enabledStartDate and enabledEndDate would be same in case we want only enabled portals
     const enabledStartDate = new Date().toISOString().split("T")[0];
     const enabledEndDate = enabledStartDate;
      return enabledPortalUrl + "?enabledstartdate="+enabledStartDate+"&enabledenddate="+enabledEndDate;

}

export const encodeBase64 = () => {

}

export const isValidJson=(data) =>{
  try {
    JSON.parse(data);
    return true;
  } catch(e) {
    return false;
  }
}

export const isPrivilegedUser = (userName, envName) => {
    return SUPER_USER_TOGGLE_DROPDOWN_ENABLED && DEPLOYMENT_ENV_WHITELIST.includes(envName) && PRIVILEGED_MSID_WHITELIST.includes(userName);
}

/*Fetches sdkPortalList from localStorage if sdkPortalList is having the shortName provided in method and it has portalGroupName then 
it returns the portal group name otherwise it returns blank
*/
export const getPortalGroupName = (portalShortNm) => {
    let sdkPortalList = JSON.parse(localStorage.getItem(SDK_PORTAL_LIST));
    if(sdkPortalList){
        const foundPortal = sdkPortalList.find(element => element.portalShortName === portalShortNm && element.portalGroupName);
        if(foundPortal){
            return foundPortal.portalGroupName;
        }
    }
    return "";
}

//Creates portal display name for Member eligibility section
export const getPortalNameForEligibilityScreen =(portalShortNm, portals) =>{
    //later need to change the logic to get portal display name for each portal
    const portalGroupName = getPortalGroupName(portalShortNm);
    const portalDisplayName = getPortalDisplayName(portalShortNm, portals);
    if(portalGroupName){
        return portalGroupName+"-"+portalDisplayName;
    }
    return portalDisplayName;
}

//Creates target url drop down list display value
export const getTargetUrlDropdownDisplayValue = (portalShortName, portalDisplayName, portalDisplayUrl) => {
    let portalGroupName = getPortalGroupName(portalShortName) ? getPortalGroupName(portalShortName)+"-": "";
    return portalGroupName+(
        portalDisplayName ? portalDisplayName : portalShortName) +
         " ( " + getPortalDisplayName(portalShortName) + ": " + portalDisplayUrl+ " )";
}

export const isPortalDisabled = (portalName, disabledPortals) => {
  return disabledPortals?.find(portal => portal === (portalName?.toUpperCase()?? portalName))
}

//Creates display value objects for target url drop down and sorts it
export const getTargetUrlDropDownSortedList = (portalsList, flag, disabledPortals, agentType) => {
    console.log(disabledPortals, flag);
    let unsortedList = [];
    if(portalsList){
      if (agentType === SESSION_BASELINEAGENT) {
        portalsList.filter(obj => obj.isBaseAgentPortal)
          .forEach(obj => unsortedList.push({
            "value": flag === ADD_ACCOUNT ? obj.prtlId : obj.portalShortName, 
            "displayUrl": obj.portalDisplayUrl, 
            "displayValue": getTargetUrlDropdownDisplayValue(obj.portalShortName,obj.portalDisplayName,obj.portalDisplayUrl), 
            "disabled": filterDisabledPortals(obj, flag, disabledPortals, agentType),
            "highLightedOption" : HIGHLIGHTED_VALUES_IN_PORTAL_DROPDOWN.includes(obj.portalShortName)
          }))
      } else {
        unsortedList = portalsList.map(obj => {
        return ({
          "value": flag === ADD_ACCOUNT ? obj.prtlId : obj.portalShortName, 
          "displayUrl": obj.portalDisplayUrl, 
          "displayValue": getTargetUrlDropdownDisplayValue(obj.portalShortName,obj.portalDisplayName,obj.portalDisplayUrl), 
          "disabled": filterDisabledPortals(obj, flag, disabledPortals, agentType),
          "highLightedOption" : HIGHLIGHTED_VALUES_IN_PORTAL_DROPDOWN.includes(obj.portalShortName)
        })});
      }
      return unsortedList.sort((a, b) => (a.displayValue > b.displayValue) ? 1 : -1);
    }
    return unsortedList;
}

const filterDisabledPortals = (obj, flag, disabledPortals, agentType) => {
  
  if (flag !== ADD_ACCOUNT && isPortalDisabled(obj.portalShortName, disabledPortals)) {
    return true;
  }

  let isDisabled = false;
  if (agentType == SESSION_BASELINEAGENT) {
    isDisabled = (obj.isSdkPortal ? isPortalNameDisabled(obj, obj.adminDisabledOperations, flag, obj.isBaseAgentPortal, disabledPortals) 
    : isExpiredPortal(obj.effDate, obj.expDate, disabledPortals));
  } else {
    isDisabled = (obj.isSdkPortal || obj.isBaseAgentPortal ? isPortalNameDisabled(obj, obj.adminDisabledOperations, flag, obj.isBaseAgentPortal, disabledPortals) 
    : isExpiredPortal(obj.effDate, obj.expDate, disabledPortals));
  }

  return isDisabled;
}

export const isExpiredPortal = (effectiveDate,expiryDate) => {
    const expDate = new Date(expiryDate).setHours(0,0,0,0);
    const effDate = new Date(effectiveDate).setHours(0,0,0,0);
    const currDate = new Date().setHours(0,0,0,0);
    const isExpired = expDate < currDate || effDate > currDate;
    return isExpired;
}

export const checkStartEndDatesBeyondGivenMonths = (dateString, givenMonths) => {
    const momentDate = moment().subtract(givenMonths, 'months').format("YYYY-MM-DD")
    const givenDate = moment(dateString)
    return givenDate.isSameOrAfter(momentDate)
}

export const compareDates = (startDate, endDate) => {
  return moment(startDate, "YYYY-MM-DD").isSameOrBefore(moment(endDate, "YYYY-MM-DD")); 
}

export const isStartDateGreaterThenEndDate = (startDate, endDate) => {
    if(startDate === '' || endDate === ''){
        return false;
    }
    startDate = new Date(startDate)
    endDate = new Date(endDate)
    if(startDate.getTime() > endDate.getTime()){
        return true
    }
    return false;
}

export const getIsHSID = (idType) => {
    if(!idType) return false
    let isHsid = true;
    if(idType === HSID_PERSONAL_REPRESENTATIVE) isHsid = false
    return isHsid
}

export const isPartialRegistration = (idType) => {
    return idType === HSID_PARTIAL_REGISTRATION;
}

export const EMAIL_MATCHER_REGEX = '[a-zA-Z\-0-9._%+-]+@[a-zA-Z\-0-9.-]+\\.[a-zA-Z]{2,}$'

export const USERNAME_NOT_AVAILABLE_MATCHER_REGEX = "Username .* is not available";
export const USER_ALREADY_EXISTS_MATCHER_REGEX = "User already exists with name";
export const USERNAME_ALREADY_EXISTS_MATCHER_REGEX = "User already exists with username";

//This method checks if the member's eligibility portal is not decommissioned
export const isPortalActive = (portalList, memberEligPortalShortName) => {
    const actualPortalDispName = getPortalDisplayName(memberEligPortalShortName);
    return portalList?.find(portal => getPortalDisplayName(portal.portalShortName) === actualPortalDispName)
            || actualPortalDispName==='MNR';
}

export const isAccountDisabled = (essoData) => {
    return essoData?.essoStatus?.enableDisableStatus === 'disabled'
}

export const isAccountUpdateRequired = (impactedMemberList) => {
  let disabled = false;
  let enabled = false;
  impactedMemberList.forEach(element => {
    if (element?.essoData?.accountStatus?.passwordStatus === "ADMINISTRATIVE_LOCK" 
    || element?.essoData?.essoStatus?.enableDisableStatus === "disabled") disabled = true;
    else enabled = true
  });
  return disabled && enabled
}

export const isAccountEnabled = (essoData) => {
    return essoData?.essoStatus?.enableDisableStatus === 'enabled'
}

export const getExternalLinkByPortalShortName = (portalShortName) => {
  switch (portalShortName) {
    case PORTAL_MAP.MYUHC:
    case PORTAL_MAP.EXCHANGE:
    case PORTAL_MAP.RALLYDHP:
    case PORTAL_MAP.YTTH2:
    case PORTAL_MAP.YTTH:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[1] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[3] },
      };

    case PORTAL_MAP.UHCMEMBERHUB:
    case PORTAL_MAP.PHSOPTUM:
    case PORTAL_MAP.PHS:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[1] },
      };

    case PORTAL_MAP.LAWW:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[1] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[5] },
      };

    case PORTAL_MAP.ALLSAVERS:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[1] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[1] },
      };

    case PORTAL_MAP.BRIOVA:
      return { viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[9] }, }

    case PORTAL_MAP.RXAARP:
    case PORTAL_MAP.AHC:
    case PORTAL_MAP.BAZ:
    case PORTAL_MAP.BCBSSC:
    case PORTAL_MAP.AHA:
    case PORTAL_MAP.AMERIHEALTH:
    case PORTAL_MAP.IBX:
    case PORTAL_MAP.OSP:
    case PORTAL_MAP.RX:
    case PORTAL_MAP.PAI:
    case PORTAL_MAP.PHP:
    case PORTAL_MAP.SRVU:
    case PORTAL_MAP.TCC:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[2] },
      };

    case PORTAL_MAP.LCP:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[3] },
      };

    case PORTAL_MAP.COMMUNITYPLAN:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[4] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[3] },
      };
    case PORTAL_MAP.MNR:
    case PORTAL_MAP.AARP:
    case PORTAL_MAP.PCP:
    case PORTAL_MAP.UHC:
    case PORTAL_MAP.UCARD:
    case PORTAL_MAP.RETIREE:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[4] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[6] },
      };

    case PORTAL_MAP.CYC_CAP:
    case PORTAL_MAP.PRUDENTIAL_CONNECT_YOURCARE:
    case PORTAL_MAP.EXTERNAL_OPTUMFINANCIAL:
    case PORTAL_MAP.ASSETHEALTH_OPTUMFINANCIAL:
    case PORTAL_MAP.FACEBOOK_OPTUMFINANCIAL:
    case PORTAL_MAP.FEDEX_OPTUMFINANCIAL:
    case PORTAL_MAP.FLCB_OPTUMFINANCIAL:
    case PORTAL_MAP.GEISINGER_OPTUMFINANCIAL:
    case PORTAL_MAP.GISI_OPTUMFINANCIAL:
    case PORTAL_MAP.JUSTWORKS_OPTUMFINANCIAL:
    case PORTAL_MAP.KFHPMAS_OPTUMFINANCIAL:
    case PORTAL_MAP.MARINCOUNTY_OPTUMFINANCIAL:
    case PORTAL_MAP.META_OPTUMFINANCIAL:
    case PORTAL_MAP.MTB_OPTUMFINANCIAL:
    case PORTAL_MAP.M_APP_OPTUMFINANCIAL:
    case PORTAL_MAP.SECURE_OPTUMFINANCIAL:
    case PORTAL_MAP.PARTNER_OPTUMFINANCIAL:
    case PORTAL_MAP.RSFH_OPTUMFINANCIAL:
    case PORTAL_MAP.SIG_OPTUMFINANCIAL:
    case PORTAL_MAP.UOPX_OPTUMFINANCIAL:
    case PORTAL_MAP.ZIONS_OPTUMFINANCIAL:
    case PORTAL_MAP.WWW_FUNDINGLIFEWISEWA:
    case PORTAL_MAP.WWW_FUNDINGPREMERAAK:
    case PORTAL_MAP.WWW_FUNDINGPREMERAWA:
    case PORTAL_MAP.PRUDENTIAL_CONNECTYOURCARE:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[5] },
      };

    case PORTAL_MAP.LEVEL2:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[6] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[4] },
      };

    case PORTAL_MAP.BANK:
    case PORTAL_MAP.CAP:
    case PORTAL_MAP.CAPDISNEY:
    case PORTAL_MAP.EMPOWER:
    case PORTAL_MAP.CAPAARP:
    case PORTAL_MAP.CAPMYUHC:
    case PORTAL_MAP.CAPOXFORD:
    case PORTAL_MAP.CAPUHCHA:
    case PORTAL_MAP.CAPUHCRA:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[7] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[7] },
      };

    case PORTAL_MAP.SS:
    case PORTAL_MAP.FHG:
    case PORTAL_MAP.GENYOU:
    case PORTAL_MAP.FH:
    case PORTAL_MAP.HSB:
    case PORTAL_MAP.UMR_BOB:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[8] },
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[3] },
      };

    case PORTAL_MAP.BSCA:
    case PORTAL_MAP.SOLSTICE:
    case PORTAL_MAP.LINCOLNFINANCIAL:
    case PORTAL_MAP.MEDIGOLD:
    case PORTAL_MAP.MORGANWHITE:
    case PORTAL_MAP.FEDVIP:
    case PORTAL_MAP.HARVARDPILGRIM:
    case PORTAL_MAP.HEALTHNET:
      return {
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[2] },
      };

    case PORTAL_MAP.GEHUB:
      return {
        mimicLink: { pathname: MIMIC_EXTERNAL_LINKS[3] },
      };

    case PORTAL_MAP.SIERRAHPN:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[12]},
        mimicLink: {pathname: MIMIC_EXTERNAL_LINKS[10]}
      };

    case PORTAL_MAP.SIERRAHPNSHL:
      return {
        viewPolicyLink: { pathname: VIEW_POLICY_EXTERNAL_LINKS[12]},
        mimicLink: {pathname: MIMIC_EXTERNAL_LINKS[10]}
      };

    default:
        return {};
  }
};

export const isExternalLinkDisabled = (link) => {
    if(link === undefined || link === null){
        return true;
    }
    return false;
}

//Utility method to copy text within the given container id to clipboard
export const copyToClipboard = (containerid) => {

    if (window.getSelection) {
        if (window.getSelection().empty) {
            window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
            window.getSelection().removeAllRanges();
        }
    } else if (document.selection) {
        document.selection.empty();
    }

    if (document.selection) {
      var range = document.body.createTextRange();
      range.moveToElementText(document.getElementById(containerid));
      range.select().createTextRange();
      document.execCommand("copy");
      return true;
    } else if (window.getSelection) {
      var range = document.createRange();
      range.selectNode(document.getElementById(containerid));
      window.getSelection().addRange(range);
      document.execCommand("copy");
      return true;
    }
    return false;
  }

  export const createSdkPortalObject = (portalConfig) => {
    let sdkPortalList = [];
    for (const key in portalConfig) {
        const element = portalConfig[key];
        let sdkPortal = {
            portalShortName : element['portalName'].toUpperCase(),
            portalDisplayName : element['uiConfig'].portalDisplayName,
            uiConfig: element['uiConfig'],
            portalDisplayUrl: element['uiConfig']?.locales?.en?.targetUrl,
            isSdkPortal: element['uiConfig'].features.isSDKPortal,
            isPePortal: element['uiConfig'].features.isPEPortal,
            isBaseAgentPortal: element['uiConfig'].features.isBaseAgentPortal,
            portalGroupName: element['uiConfig'].features.portalGroupName,
            adminDisabledOperations: element['uiConfig'].features.adminDisabledOperations
        };
        sdkPortalList.push(sdkPortal);
    }
    return sdkPortalList;
}

export const concatePortals = (portalList, sdkPortalList, screen) => {
    if (sdkPortalList) {
        if(screen==="addAccount"){
          sdkPortalList = sdkPortalList.filter(sdkPortal => !portalList.some(portal => portal.portalShortName === sdkPortal.portalShortName));
        }else{
          portalList = portalList.filter(portal => !sdkPortalList.some(sdkPortal => sdkPortal.portalShortName === portal.portalShortName));
        }
        portalList = portalList.concat(sdkPortalList.filter(p => p.uiConfig.features.adminDisabledOperations ? p.uiConfig.features.adminDisabledOperations?.[screen] !== true : p));
    }
    return portalList;
}